export const SET_USER_EMAIL = 'store/masterSettings/GET_SETTINGS'
export const SET_INVITE_RESPONSE = 'store/masterSettings/INVITE_RESPONSE'


// WEBPACK FOOTER //
// ./src/actionTypes/Headers/headers.js